import _Subtitle from './Subtitle'
import _Title from './Title'
import _Input from './Input'
import _TextArea from './TextArea'
import _Paragraph from './Paragraph'
import _CreateBtn from './CreateBtn'
import _DatePicker from './DatePicker'
import _TimePicker from './TimePicker'
import _UploadBtn from './UploadBtn'
import _SmallBtn from './SmallBtn'
import _MediumBtn from './MediumBtn'
import _Select from './Select'

export const Subtitle = _Subtitle
export const Title = _Title
export const Input = _Input
export const TextArea = _TextArea
export const Paragraph = _Paragraph
export const CreateBtn = _CreateBtn
export const DatePicker = _DatePicker
export const TimePicker = _TimePicker
export const UploadBtn = _UploadBtn
export const SmallBtn = _SmallBtn
export const MediumBtn = _MediumBtn
export const Select = _Select



// WEBPACK FOOTER //
// ./src/components/Regular/index.js